import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetReviewEditorsArgsType = GetRequestArgsType & {
  reviewCode: string;
  reviewEditorId?: number | null;
};

export type ReviewEditorBatchUpdateSerializerType = {
  tenantUserIds: Array<number>;
};

export type BatchUpdateReviewEditorsArgsType = (
  PostRequestArgsType<ReviewEditorBatchUpdateSerializerType> & {
    reviewCode: string;
  }
);

export const apiFetchReviewEditors = async ({
  domain = useTenantStore().domain,
  reviewCode,
  reviewEditorId = null,
  errorConfig = {},
  callbacks = {},
}: GetReviewEditorsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.reviewEditors({ domain, reviewCode, reviewEditorId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiBatchUpdateReviewEditors = async ({
  domain = useTenantStore().domain,
  reviewCode,
  payload,
  errorConfig = {},
  callbacks = {},
}: BatchUpdateReviewEditorsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.reviewEditorBatchUpdate({ domain, reviewCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
